import React, { useState, useRef, useEffect } from "react";
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
} from "react-image-crop";
import { avtarProfileImage, ProfileImg as pic } from "../../../assets/images";
import { CameraIcon, UploadImgIcon } from "../../../assets/images";
import "react-image-crop/dist/ReactCrop.css";
import { BlobServiceClient } from "@azure/storage-blob";
import "./ProfilePhoto.scss";
import { UploadFileTypesPayload } from "../../../commonTypes/fileManagerTypes";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { UserProfileType } from "../../../redux/auth/authTypes";
import { CanvasPreview } from "./CanvasPreview";
import ProfileLoader from "../../../screens/AllUsersAndClients/UserProfileEdit/ProfileLoader";

type AppProps = {
  data: any;
  type?: string;
  setProfileForm: any;
  isEdit?: boolean | string;
};

function centerAspectCrop(
  mediaWidth: number,
  mediaHeight: number,
  aspect: number
) {
  return centerCrop(
    makeAspectCrop(
      {
        unit: "px",
        width: 200,
        height: 200,
      },
      aspect,
      mediaWidth,
      mediaHeight
    ),
    mediaWidth,
    mediaHeight
  );
  // setCrop()
}

const ProfilePhoto = ({ data, setProfileForm, isEdit, type }: AppProps) => {
  const [imgSrc, setImgSrc] = useState("");

  const previewCanvasRef = useRef<HTMLCanvasElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);
  const [crop, setCrop] = useState<Crop>();
  const [completedCrop, setCompletedCrop] = useState<Crop>({
    unit: "px",
    width: 50,
    height: 50,
    x: 25,
    y: 25,
  });

  const [scale, setScale] = useState(1);
  const [rotate, setRotate] = useState(0);
  const [aspect, setAspect] = useState<number | undefined>(1);
  const [onCancel, setOnCancel] = useState(false);
  const [fileModel, setFileModel] = useState(false);
  const [loader, setLoder] = useState(false);

  const [showImg, setShowImg] = useState<any>(); //show previous image
  const fileUploadRef = React.createRef<any>();

  const [picture, setPicture] = useState<any>(null);

  const [showCrop, setShowCrop] = useState(false);
  const [fileMessage, setFileMessage] = useState(
    "Upload file size up to 5MB with format only PNG or JPEG."
  );
  const [fileError, setFileError] = useState("");

  let firstName = data?.basic_details?.first_name?.trim()[0]?.toUpperCase();
  let lastname = data?.basic_details?.last_name?.trim()[0]?.toUpperCase();

  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  let blobSasUrl = `${blobBaseUrl}?${blobToken}`;

  const blobServiceClient = new BlobServiceClient(blobSasUrl);
  const containerName = `profile`;
  const containerClient = blobServiceClient.getContainerClient(containerName);
  const uploadFiles = async (uploadedFile: any) => {
    setLoder(true);
    try {
      let resp;
      const blockBlobClient = containerClient.getBlockBlobClient(
        new Date().valueOf() +
        "." +
        uploadedFile.name.split(".")[uploadedFile.name.split(".").length - 1]
      );
      resp = await blockBlobClient.uploadBrowserData(uploadedFile);
      if (
        resp &&
        resp["_response"] &&
        resp["_response"].status &&
        resp["_response"].status === (201 || 200)
      ) {
        updateDocumentAPI(
          uploadedFile.name,
          blockBlobClient["_name"],
          blockBlobClient["_containerName"],
          uploadedFile.type
        );
      } else {
        alert("something wrong");
      }
    } catch (error) { }
  };
  useEffect(() => {
    if (
      completedCrop?.width &&
      completedCrop?.height &&
      imgRef.current &&
      previewCanvasRef.current
    ) {
      CanvasPreview(
        imgRef?.current,
        previewCanvasRef.current,
        completedCrop,
        scale,
        rotate
      );
    }
  }, [completedCrop, crop, imgRef, showCrop]);

  useEffect(() => {
    let showImg = data?.profile_pic
      ? `${blobBaseUrl}${data?.profile_pic?.file_url}?${blobToken}`
      : !firstName && !lastname
        ? avtarProfileImage
        : pic;

    setShowImg(showImg);
  }, [data?.profile_pic, firstName, lastname]);

  const updateDocumentAPI = (
    file_name: string,
    url_name: string,
    url_container: string,
    file_type: string
  ) => {
    let data: UploadFileTypesPayload = {
      file_name,
      file_url: url_container + "/" + url_name,
      file_type,
    };

    setProfileForm((prv: any) => {
      return type === "Recuritment" ? {
        ...prv,
        applicantDetails: {
          ...prv.applicantDetails,
          profile_pic: data,
        },
      } : {
        ...prv,
        user_details: {
          ...prv.user_details,
          profile_pic: data,
        },
      };
    });
    setLoder(false);
    // handleUploadFile?.(data);
  };

  function onSelectFile(e: React.ChangeEvent<HTMLInputElement>) {
    let type;
    let size = 5242880;
    if (e.target.files && e.target.files.length > 0) {
      type = e.target.files[0].type;
      size = e.target.files[0].size;
    }
    if (
      e.target.files &&
      e.target.files.length > 0 &&
      (type === "image/png" || type === "image/jpeg") &&
      size <= 5242880
    ) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImgSrc(reader.result?.toString() || "");
        setShowCrop(true);
        setFileError("");
      });
      setOnCancel(true);
      reader.readAsDataURL(e.target.files[0]);
      // uploadFiles(e.target.files[0]);
    } else if (size > 5242880) {
      setFileError("You can upload file upto 5 mb");
    } else {
      setFileError("This file type is not supported.Please choose an image");
    }
  }

  function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
    if (aspect) {
      const { width, height } = e.currentTarget;
      setCrop(centerAspectCrop(width, height, aspect));
      setCompletedCrop(centerAspectCrop(width, height, aspect));
    }
  }

  const handlefileUploadRefClick = () => {
    setFileError("");
    fileUploadRef.current.click();
  };

  const onCropComplete = (e: any) => {
    setCompletedCrop(e);
  };

  const handleCropImage = () => {
    if (
      completedCrop?.width &&
      completedCrop?.height &&
      // imgRef.current &&
      previewCanvasRef.current
    ) {
      var canvas = previewCanvasRef?.current;
      var dataURL = canvas?.toDataURL();

      const dataURLtoFile = (dataurl: any, filename: any) => {
        var arr = dataurl?.split(","),
          mime = arr[0]?.match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr?.length,
          u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr?.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      };

      var file1 = dataURLtoFile(dataURL, "image.jpg");

      uploadFiles(file1);
    }
    setFileModel(false);
    setOnCancel(false);
  };

  const handleClick = (event: any) => {
    const { target = {} } = event || {};
    target.value = "";
  };

  const handleDeletePropfile = () => {
    setProfileForm((prv: any) => {
      return type === "Recuritment" ? {
        ...prv,
        applicantDetails: {
          ...prv.applicantDetails,
          profile_pic: null,
        },
      } : {
        ...prv,
        user_details: {
          ...prv.user_details,
          profile_pic: null,
        },
      };
    });
  };
  return (
    <div>
      <div className="profile-photo">
        {loader ? <ProfileLoader /> : ""}

        <img
          className="profile-image border border-secondary"
          src={
            data?.profile_pic
              ? `${blobBaseUrl}${data?.profile_pic?.file_url}?${blobToken}`
              : !firstName && !lastname
                ? avtarProfileImage
                : pic
          }
          alt="Profile Img"
        />

        {!!completedCrop && (
          <canvas
            ref={previewCanvasRef}
            style={{
              border: "1px solid black",
              objectFit: "contain",
              width: completedCrop.width,
              height: completedCrop.height,
              display: "none",
            }}
          />
        )}
        {!data?.profile_pic && (
          <h3>{`${firstName?.length ? firstName : ""}${lastname?.length ? lastname : ""
            }`}</h3>
        )}

        <input
          type="file"
          accept="image/*"
          onChange={onSelectFile}
          className="camera-icon"
          ref={fileUploadRef}
          style={{ display: "none" }}
          onClick={handleClick}
        />
        {isEdit && (
          <img
            src={CameraIcon}
            alt="camera icon"
            className="camera-icon"
            style={{ cursor: isEdit ? "pointer" : "auto" }}
            onClick={() => {
              if (isEdit) {
                setOnCancel(!onCancel);
                setShowCrop(false);
              }
            }}
          />
        )}

        {onCancel && (
          <Modal
            isOpen={onCancel}
            size="lg"
            toggle={() => setOnCancel(true)}
            style={{ width: "77%" }}
          >
            <ModalHeader
              toggle={(e: any) => {
                setOnCancel(false);
                setShowCrop(false);
                setFileError("");
              }}
            >
              {showCrop ? `Edit Photo` : `View Photo`}
              <div>
                <p style={{ marginTop: "-9px", marginBottom: 0, padding: 0 }}>
                  <span style={{ color: "gray", fontSize: "12px" }}>
                    {fileMessage ? fileMessage : ""}
                  </span>
                </p>
              </div>
            </ModalHeader>
            <ModalBody
              style={{
                background: showCrop ? "" : "#262a44",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {showCrop && (
                <ReactCrop
                  crop={crop}
                  onChange={(_, percentCrop) => setCrop(percentCrop)}
                  onComplete={onCropComplete}
                  aspect={aspect}
                  circularCrop={true}
                >
                  <img
                    ref={imgRef}
                    alt="Crop me"
                    src={imgSrc}
                    style={{
                      transform: `scale(${scale}) rotate(${rotate}deg)`,
                    }}
                    onLoad={onImageLoad}
                  />
                </ReactCrop>
              )}
              {!showCrop && (
                <>
                  <div className="show-img-modal">
                    <img
                      alt="Crop me"
                      src={showImg}
                      className="show-crop-img"
                    />

                    {!data?.profile_pic && (
                      <h3>{`${firstName?.length ? firstName : ""}${lastname?.length ? lastname : ""
                        }`}</h3>
                    )}
                  </div>
                </>
              )}
            </ModalBody>
            <ModalFooter>
              <span style={{ color: "#e7733e", fontSize: "14px" }}>
                {fileError ? fileError : ""}
              </span>
              <button
                className="btn btn-outline"
                onClick={handleDeletePropfile}
                disabled={!data?.profile_pic}
              >
                Delete
              </button>
              {showCrop ? (
                <Button color="primary ml-3" onClick={handleCropImage}>
                  Save Photo
                </Button>
              ) : (
                <Button color="primary ml-3" onClick={handlefileUploadRefClick}>
                  <img src={UploadImgIcon} alt="" /> Upload New Photo
                </Button>
              )}
            </ModalFooter>
          </Modal>
        )}

        {!!completedCrop && (
          <canvas
            ref={picture}
            style={{
              objectFit: "contain",
              width: completedCrop.width,
              height: completedCrop.height,
              display: "none",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default ProfilePhoto;
